import React from 'react';
import i18next from 'i18next';
import { connect } from 'react-redux';
import PendingButton from '../Button/PendingButton';
import apiForm from './apiForm';
import SumInput from '../SumInput/SumInput';
import Api from '../../api';
import FormErrors from './FormErrors';
import makeCancelable from '../../api/cancelable';
import { numberWithSpaces } from '../../utils';
import CurrencySwitch from '../CurrencySwitch/CurrencySwitch';
import ButtonBorder from '../Button/ButtonBorder';

class ExchangeForm extends React.PureComponent {
  constructor(props) {
    super(props);

    this.requests = [];
  }

  componentWillUnmount() {
    this.requests.forEach((cancel) => cancel());
  }

  onSubmit = (e) => {
    const { promise, cancel } = makeCancelable(
      Api.exchange(this.props.serializeForm(e.currentTarget))
    );
    this.requests.push(cancel);

    e.preventDefault();
    this.props.beforeSubmit();
    promise.then((response) => {
      this.props.afterSubmit(response);
    });
  };

  balanceFrom = (from) => {
    const { balance, balanceCash } = this.props;

    return from === 'REX' ? balance : balanceCash;
  };

  render() {
    const {
      balance,
      balanceCash,
      onInputChange,
      customTitle,
      reset,
      formState: { pending, errors, invalid, submitted, values },
    } = this.props;
    const blockSubmit = values.amount <= 0;

    return (
      <div className="form exchange-form">
        <form onSubmit={this.onSubmit}>
          <span className="form__title form__title--center form__title--secondary">
            {customTitle || i18next.t('exchange.title')}
          </span>

          {(!submitted || errors.length !== 0) && (
            <React.Fragment>
              <CurrencySwitch
                from={values.currencyFrom}
                to={values.currencyTo}
                onChange={(from, to) => {
                  onInputChange('currencyFrom', from);
                  onInputChange('currencyTo', to);
                  onInputChange(
                    'amount',
                    Math.min(values.amount, this.balanceFrom(from))
                  );
                }}
              />

              <SumInput
                sum={+values.amount}
                onChange={onInputChange.bind(this, 'amount')}
                min={0}
                max={this.balanceFrom(values.currencyFrom)}
                showMinMax={false}
              />

              <FormErrors errors={errors} />

              {balance !== null && (
                <div className="exchange-form__max-sum">
                  {i18next.t('exchange.max')}
                  {values.currencyFrom === 'REX'
                    ? `${numberWithSpaces(balance)} REX`
                    : `${numberWithSpaces(balanceCash)} CASH`}
                  <span
                    className="form__link link link--blue"
                    onClick={() =>
                      onInputChange(
                        'amount',
                        this.balanceFrom(values.currencyFrom)
                      )
                    }
                  >
                    {i18next.t('exchange.use_max')}
                  </span>
                </div>
              )}
            </React.Fragment>
          )}

          {submitted && errors.length === 0 ? (
            <React.Fragment>
              <span className="form__title form__title--center">
                {i18next.t('exchange.success')}
              </span>
              <ButtonBorder className="form__center" onClick={reset}>
                {i18next.t('exchange.ok')}
              </ButtonBorder>
            </React.Fragment>
          ) : (
            <PendingButton
              tagName="button"
              className="form__submit"
              onClick={this.onSubmit}
              disabled={blockSubmit}
              pending={pending}
              done={submitted && errors.length === 0}
            >
              {i18next.t('exchange.action')}
            </PendingButton>
          )}
        </form>
      </div>
    );
  }
}

export default connect((state) => {
  return {
    balance: state.user.balance,
    balanceCash: state.user.balanceCash,
  };
}, {})(
  apiForm(ExchangeForm, {
    values: {
      amount: 0,
      currencyFrom: 'REX',
      currencyTo: 'CASH',
    },
  })
);



// WEBPACK FOOTER //
// ./app/components/Form/ExchangeForm.jsx